export const useGetSQUIPForWeb = () => {
  const host = window.location.host;
  const squip = getSQUIPForHost(host);

  return squip;
};

const getSQUIPForHost = (host: string) => {
  const isPatronReviewApp =
    host.startsWith("deploy-preview-") &&
    host.endsWith("--whoosh-patron-master.netlify.app");

  //Staging & ALPHA & Replica
  if (
    host.includes("staging.whoosh") ||
    host.includes("alpha.whoosh") ||
    host.includes("replica.whoosh")
  ) {
    return "sandbox-sq0idb-8q2oFTKR-rJaDKxDI-VlEw";
  }
  //DEMO & Review
  else if (host.includes("demo.whoosh") || isPatronReviewApp) {
    return "sq0idp-P-9ak0IcV0EvuO_1hLWKyw";
  }
  //PROD
  else if (host.includes("app.whoosh")) {
    return "sq0idp-TIMaoqtfW892Oc2EHSQnKA";
  }
  //Everything Else (Dev)
  else {
    return "sandbox-sq0idb-R63u7uIK2Z2Sh4DMQd_KNg";
  }
};
